import React, { useRef, useState, useEffect } from "react";
import HeadLines from "../../CommonComponents/HeadLines";
import { isMobile } from "../../helperFunc";
import style from "./style.module.css";
import { RightArrowBlack } from "../../icon_assets";
import Button from "../../CommonComponents/Button";
import FlexComponentMobile from "../../Trade/Listing/HomepageRevamp4.0/FlexComponentMobile/FlexComponentMobile";
import { useHistory } from "react-router";
import InvoiceCardItem from "./InvoiceItemCard";
import useIsUserLoggedIn from "../../CustomHooks/useIsUserLoggedIn";
import { getPendingItems } from "../../../../../_services/Arya2.0/Homepage";
import { customToastr } from "../../CustomToastr";
import MultiLangTranslate from "../../../../../_components/Translate/MultiLangTranslate";

const InvoiceCard = () => {
  const history = useHistory();
  const cardContainerRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [data, setData] = useState([]);
  const [userLoggedIn] = useIsUserLoggedIn();

  // Fetch pending items
  const getPendingItemsData = async () => {
    try {
      const response = await getPendingItems();
      if (response?.status_code === 200 && response?.data?.length > 0) {
        setData(response?.data);
      }
    } catch (error) {
      customToastr({
        type: "warning",
        timeOut: 3000,
        text: error?.message || "Something went wrong",
      });
    }
  };

  // Fetch data when user is logged in
  useEffect(() => {
    if (userLoggedIn) {
      getPendingItemsData();
    }
  }, [userLoggedIn]);

  const scrollAmount = isMobile ? 396 : 300;
  const visibleCards = isMobile ? 1 : 2;
  const maxDots = 4;
  const numDots = Math.min(Math.ceil(data?.length / visibleCards), maxDots);

  const handleScrollRight = () => {
    if (activeIndex < data?.length - visibleCards) {
      setActiveIndex((prevIndex) => prevIndex + 1);
    }
  };

  const handleScrollLeft = () => {
    if (activeIndex > 0) {
      setActiveIndex((prevIndex) => prevIndex - 1);
    }
  };

  const scrollToCard = (index) => {
    if (cardContainerRef.current) {
      const scrollLeft = index * scrollAmount;
      cardContainerRef.current.scrollTo({
        left: scrollLeft,
        behavior: "smooth",
      });
      setActiveIndex(index);
    }
  };

  const handleDotClick = (index) => {
    scrollToCard(index);
  };

  const handleClick = (index, data) => {
    if (data?.buttonLabel === "Pay Now") {
      history.push(
        `/ltp-stp-buyer-invoice-detail?invoice_id=${data?.invoiceId}&contract_id=${data?.contractId}&invoice_type=${data?.invoiceType}`
      );
    } else if (data?.buttonLabel === "Accept Disbursement Request") {
      history.push(`/disbursement/${data?.sr_id}`);
    }
  };

  const handleViewAll = () => {
    history.push("/pending-invoices");
  };

  useEffect(() => {
    scrollToCard(activeIndex);
  }, [activeIndex]);

  return (
    <>
      {data && data?.length > 0 && (
        <>
          {isMobile ? (
            <FlexComponentMobile
              leftTitle="My Pending Items"
              rightNumber={data?.length || 0}
            />
          ) : (
            <div className="d-flex align-items-center justify-content-space-between">
              <div className="d-flex align-items-center gap8">
                <HeadLines
                  text="My Pending Items"
                  className={`font-weight500 font-size18 line-height21 colorDark5`}
                />
                <HeadLines
                  text={String(data?.length || 0).padStart(2, "0")}
                  className={`font-weight500 font-size18 line-height21 backAccent3 textColorWhite boxRadius4 ${style.padding4_5}`}
                />
              </div>
              <div className="d-flex align-items-center gap20">
                {data?.length > 4 && (
                  <div
                    onClick={handleViewAll}
                    className="font-size16 line-height19 colorAccent3 font-weight500 cursorPointer"
                  >
                    <MultiLangTranslate title="View All" />
                  </div>
                )}
                <div className="d-flex align-items-center gap10">
                  <div
                    onClick={handleScrollLeft}
                    className={`${style.ArrowBackGround} boxRadius8 cursorPointer`}
                  >
                    <img
                      src={RightArrowBlack}
                      alt="Right Arrow Light"
                      className={`${style["leftArrow"]} ${
                        activeIndex === 0 && style["opacity04"]
                      }`}
                      style={{
                        width: isMobile ? "" : "24px",
                        height: isMobile ? "" : "24px",
                      }}
                    />
                  </div>
                  <div
                    onClick={handleScrollRight}
                    className={`${style.ArrowBackGround} boxRadius8 cursorPointer`}
                  >
                    <img
                      src={RightArrowBlack}
                      alt="Right Arrow Black"
                      className={`${
                        activeIndex >= data?.length - visibleCards &&
                        style["opacity04"]
                      }`}
                      style={{
                        width: isMobile ? "" : "24px",
                        height: isMobile ? "" : "24px",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

          <div
            ref={cardContainerRef}
            className={`d-flex align-items-center margin-top14 ${
              style.scrollBarNone
            }
              ${
                isMobile
                  ? `${style.mobileShadow} ${style["mobCardContainer"]}`
                  : `${style.cardContainer}`
              }`}
          >
            {data?.map((item, index) => (
              <InvoiceCardItem
                key={index}
                item={{
                  ...item,
                  invoiceHeading: item?.title,
                  invoiceAmount: item?.amount,
                  invoiceLink: item?.downloadInvoiceId,
                }}
                index={index}
                handleClick={handleClick}
              />
            ))}
          </div>

          {isMobile && (
            <div className="d-flex align-items-center justify-content-space-between gap10 margin-bottom40 margin-top20">
              <div className="d-flex align-items-center gap10">
                {Array.from({ length: numDots }).map((_, index) => (
                  <div
                    key={index}
                    className={
                      index === activeIndex
                        ? style.activeRoundDot
                        : style.roundDot
                    }
                    onClick={() => handleDotClick(index)}
                  ></div>
                ))}
              </div>
              {data?.length > 4 && (
                <Button
                  title="View All"
                  onClick={handleViewAll}
                  className={`font-size14 line-height16 colorAccent3 font-weight500 cursorPointer ${style.transparentbackground}`}
                />
              )}
            </div>
          )}
        </>
      )}
    </>
  );
};

export default InvoiceCard;
